import styled from 'styled-components';

export const GeomapWidgetGraphStyled = styled.div`
  width: 100%;
  height: 100%;
  z-index: 100;

  .am5-html-container {
    overflow: visible !important;
  }
`;
